import { useEffect, useState } from 'react'

// 2026-07-29 20:00 US Eastern (EDT, UTC-4) = 2026-07-30T00:00:00Z.
// Displayed as "EST" per the operator's copy; computed against actual
// Eastern wall-clock time so the zero lands at 8:00 PM in New York.
export const COUNTDOWN_TARGET_MS = Date.parse('2026-07-30T00:00:00Z')
export const COUNTDOWN_LABEL = 'wed jul 29 · 8:00 pm est'

function remaining(now: number) {
  const ms = Math.max(0, COUNTDOWN_TARGET_MS - now)
  const s = Math.floor(ms / 1000)
  return {
    done: ms === 0,
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    mins: Math.floor((s % 3600) / 60),
    secs: s % 60,
  }
}

const pad = (n: number) => String(n).padStart(2, '0')

export function Countdown({ caption = COUNTDOWN_LABEL }: { caption?: string }) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [])

  const r = remaining(now)

  return (
    <div className="mt-4 flex flex-col items-center gap-1 border border-lime-soft bg-crt-panel px-4 py-3 shadow-glow">
      <div className="text-[10px] uppercase tracking-[0.25em] text-crt-gray">
        {r.done ? 'live' : `t-minus // ${caption}`}
      </div>
      {r.done ? (
        <div className="font-mono text-3xl font-bold text-crt-lime [text-shadow:0_0_12px_rgba(207,255,4,0.45)]">
          LIVE NOW
        </div>
      ) : (
        <div
          className="flex items-baseline gap-2 font-mono text-4xl font-bold tabular-nums text-crt-lime [text-shadow:0_0_12px_rgba(207,255,4,0.45)] md:text-5xl"
          aria-label={`countdown to ${caption}`}
        >
          <span>{pad(r.days)}</span>
          <span className="text-crt-dim">:</span>
          <span>{pad(r.hours)}</span>
          <span className="text-crt-dim">:</span>
          <span>{pad(r.mins)}</span>
          <span className="text-crt-dim">:</span>
          <span>{pad(r.secs)}</span>
        </div>
      )}
      {!r.done && (
        <div className="flex gap-6 text-[9px] uppercase tracking-[0.3em] text-crt-dim">
          <span>days</span>
          <span>hrs</span>
          <span>min</span>
          <span>sec</span>
        </div>
      )}
    </div>
  )
}
